import { render, staticRenderFns } from "./vuex-number-input.vue?vue&type=template&id=13e6cc5d"
import script from "./vuex-number-input.vue?vue&type=script&lang=js"
export * from "./vuex-number-input.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports